import React from 'react';
import { Card, Tabs } from 'antd';
import { useParams } from 'react-router-dom';
import CompanyAdvHomeTab from './CompanyAdvHomeTab';
import CompanyAdvPromoTab from './CompanyAdvPromoTab';

const { TabPane } = Tabs;

const CompanyAdvTabs: React.FC = () => {
  const { companyId } = useParams() as { companyId: string };

  return (
    <Card>
      <Tabs defaultActiveKey='home'>
        <TabPane tab='Главный экран' key='home'>
          <CompanyAdvHomeTab />
        </TabPane>
        <TabPane tab='Промо-акции' key='promo'>
          <CompanyAdvPromoTab />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default CompanyAdvTabs;
